module.exports = __webpack_public_path__ + "static/media/bg.1987013f.jpg";